import React from 'react'
import { useLocation } from 'react-router-dom'



const SkillsDetails = () => {
    const data = useLocation().state

  return (
    <div>
        <h2 className='head-text' style={{paddingTop:'15vh'}}>
            {data?.year}
        </h2>

        <div>
            <div style={{paddingTop:'40px',paddingLeft:'40px', display:'flex', alignItems:'center'}}>
                <h3 >Role : </h3>
                <h3 style={{fontWeight:'lighter'}}>{data.works[0]?.name}</h3>
            </div>
            <div style={{paddingTop:'10px',paddingLeft:'40px', display:'flex', alignItems:'center'}}>
                <h3 >Company : </h3>
                <h3 style={{fontWeight:'lighter'}}>{data.works[0]?.company}</h3>
            </div>
            <div style={{paddingTop:'10px',paddingLeft:'40px', display:'flex', alignItems:'center'}}>
                <h3 >Technologies : </h3>
                <h3 style={{fontWeight:'lighter'}}>{data.works[0]?.technology}</h3>
            </div>
            <div style={{paddingTop:'10px',paddingLeft:'40px', alignItems:'center'}}>
                <h3 style={{}}>Details : </h3>
                <h3 style={{fontWeight:'lighter'}}>{data.works[0]?.desc}</h3>
            </div>
        </div>
    </div>
  )
}

export default SkillsDetails